import { atom } from "jotai";
export const ninjaCodeAtom = atom<string>("");
export const ninjaOauthTokenAtom = atom<string>("");

/**
 * True while a Datto mapping step is still walking its paged list.
 *
 * The step's Next/Finish button lives in IntegrationsDetailsScreen while the
 * fetch lives in the mapping components, and saving mid-walk writes a partial
 * full-replace — so the button has to read the child's progress. Jotai rather
 * than prop-threading through DattoMainWrapper, per the project's no-Context
 * convention for feature state.
 */
export const isDattoMappingListLoadingAtom = atom<boolean>(false);
